module.exports = __webpack_public_path__ + "static/specSheet-a08545e75e0f0c567d7f4ec7277e557d.svg";